import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IGroupsParams, IGroupsResponse, IGroupsState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchListGroups = createAsyncThunk(
  'listGroups/fetchListGroups',
  async ({ query }: IGroupsParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.getGroups(query)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IGroupsState = {
  isLoading: false,
  response: null,
  error: null
}

const listGroupsSlice = createSlice({
  name: 'groups/list',
  initialState,
  reducers: {
    resetListGroups: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchListGroups.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchListGroups.fulfilled, (state, action: PayloadAction<IGroupsResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchListGroups.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default listGroupsSlice.reducer
export const { resetListGroups } = listGroupsSlice.actions
